module.exports = __webpack_public_path__ + "img/img-blank.2c29b0f9.svg";